var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJiraLogo = function SvgJiraLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.932,
    height: 13.5,
    viewBox: "0 0 37.932 13.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.918,
    x2: 0.283,
    y1: 1.856,
    y2: 1.442,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.087,
    x2: 0.721,
    y1: -0.327,
    y2: 0.086,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#253858}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    transform: "translate(-22 -282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blue",
    transform: "translate(22 282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_289",
    d: "M119.625 291.2h1.43v7.128c0 1.881-.848 3.193-2.825 3.193a5.4 5.4 0 0 1-1.73-.259V299.9a3.949 3.949 0 0 0 1.483.259c1.218 0 1.642-.708 1.642-1.726z",
    className: "cls-1",
    transform: "translate(-100.141 -289.576)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_290",
    d: "M152.643 287.989a.885.885 0 0 1 .954.812v.121a.954.954 0 0 1-1.907 0 .879.879 0 0 1 .83-.933zm-.689 3.011h1.377v7.81h-1.377z",
    className: "cls-1",
    transform: "translate(-129.204 -286.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_291",
    d: "M172.7 304.87h1.342v1.413a2.656 2.656 0 0 1 2.825-1.519v1.342c-1.766-.177-2.825.353-2.825 2.048v4.715H172.7z",
    className: "cls-1",
    transform: "translate(-146.606 -300.975)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_292",
    d: "M205.3 311.21a2.8 2.8 0 0 1-2.7 1.589c-2.119 0-3.2-1.8-3.2-4.15 0-2.26 1.112-4.15 3.355-4.15a2.62 2.62 0 0 1 2.543 1.572v-1.413h1.377v7.981H205.3zm-2.331.318a2.273 2.273 0 0 0 2.331-2.56v-.653c0-1.766-1.007-2.56-2.172-2.56-1.554 0-2.348 1.024-2.348 2.878 0 1.925.759 2.9 2.19 2.9z",
    className: "cls-1",
    transform: "translate(-168.743 -300.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_301",
    fill: "#2684ff",
    d: "M35.12 288.368l-5.92-5.813-.561-.555-4.45 4.373-2.031 2a.538.538 0 0 0 0 .764l4.061 3.991 2.419 2.377 4.45-4.373.071-.069 1.96-1.926a.538.538 0 0 0 .001-.769zm-6.5 2.377l-2.031-2 2.031-2 2.031 2z",
    transform: "translate(-22 -282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_302",
    fill: "url(#linear-gradient)",
    d: "M38.667 286.921a3.421 3.421 0 0 1-.018-4.821l-4.45 4.45 2.419 2.419z",
    transform: "translate(-32.046 -282.082)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_303",
    fill: "url(#linear-gradient-2)",
    d: "M61.531 320.8l-2.031 2.031a3.41 3.41 0 0 1 0 4.838l4.467-4.467z",
    transform: "translate(-53.008 -314.187)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJiraLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jira_logo.41023acb.svg";
export { ForwardRef as ReactComponent };